import React from 'react';
import {
  SpacedTexts,
  OriginAddressContainer,
  DestinationAddressContainer
} from './styles';

const ProgressBarRoute = ({ origin, destination }) => (
  <SpacedTexts>
    <OriginAddressContainer
      variant="body2"
      color="textSecondary"
    >
      {origin}
    </OriginAddressContainer>
    {destination ?
      <DestinationAddressContainer
        variant="body2"
        color="textSecondary"
      >
        {destination}
      </DestinationAddressContainer> : <span />}
  </SpacedTexts>
);

export default ProgressBarRoute;
